// import "./plantCBConsumption.css";
import { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import * as React from 'react';
import { authKey, PLANT_CONSUMPTION } from "../../../common/URLs";
import { loaderService } from "../../../common/custom-loader/loader-service";

import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { ErrorPopover } from "../../../common/ErrorPopover/errorPopover";
import { confirmAlert } from "react-confirm-alert";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { handleNumberFieldFocus } from "../../../common/commonFunction";

function TransporterEntry() {

    const navigate = useNavigate();


    const [plantConsumptionResponse, setPlantConsumptionResponse] = React.useState();
    const [consumptionDetails, setConsumptionDetails] = React.useState({
        "date": "",
        "consumptionQuantity": "",
        "totalCbQuantityDelivered": "",
        // "eodInventory": "",
        "unrestrictedQuantity": "",
        "restrictedQuantity": "",
        "scrapQuantity": ""
    });
    const [errorMessage, setErrorMessage] = React.useState({
        "dateError": "",
        "consumptionQuantityError": "",
        "totalCbQuantityDeliveredError": "",
        // "eodInventoryError": "",
        "unrestrictedQuantityError": "",
        "restrictedQuantityError": "",
        "scrapQuantityError": ""
    });


    // const addPlantConsumption = (e) => {
    //     loaderService.showLoader();
    //     apiClient
    //       .post(
    //         PLANT_CONSUMPTION,
    //         {
    //          "date": "",
    //          "consumptionQuantity": consumptionDetails.consumptionQuantity,
    //          "totalCbQuantityDelivered": consumptionDetails.totalCbQuantityDelivered,
    //         //  "eodInventory": consumptionDetails.eodInventory,
    //          "unrestrictedQuantity": consumptionDetails.unrestrictedQuantity,
    //          "restrictedQuantity": consumptionDetails.restrictedQuantity,
    //          "scrapQuantity": consumptionDetails.scrapQuantity

    //           },
    //         {
    //           headers: {
    //             Authorization: "Bearer " + getLocalStorageItem('id_token'),
    //           },
    //         }
    //       )
    //       .then((response) => {
    //         setPlantConsumptionResponse(response.data);
    //         loaderService.hideLoader();
    //       })
    //       .catch(function (error) {
    //         console.log("apiClientERROR", error);
    //         loaderService.hideLoader();
    //       });
    //   };

    //   const onSubmit=(e)=> {
    //     e.preventDefault();
    //     if (!consumptionDetails?.consumptionQuantity) {
    //         setErrorMessage({ ...errorMessage, consumptionQuantityError: "Please enter consumption quantity" });
    //       }
    //       else if (!consumptionDetails?.totalCbQuantityDelivered) {
    //         setErrorMessage({ ...errorMessage, totalCbQuantityDeliveredError: "Please enter total chipped bamboo delivered" });
    //       }
    //       // else if (!consumptionDetails?.eodInventory) {
    //       //   setErrorMessage({ ...errorMessage, eodInventoryError: "Please enter plant inventory at the end of the day" });
    //       // }
    //       else if (!consumptionDetails?.unrestrictedQuantity) {
    //         setErrorMessage({ ...errorMessage, unrestrictedQuantityError: "Please enter unrestricted quantity" });
    //       }

    //     else {
    //         addPlantConsumption();
    //     }

    //   }

    //   const handleChange=(e) =>{
    //     setConsumptionDetails({...consumptionDetails, [e.target.name]: e.target.value});
    //       if (e.target.name === "consumptionQuantity") 
    //       {
    //         setErrorMessage({ ...errorMessage, consumptionQuantityError: "" });
    //       }
    //       if (e.target.name === "totalCbQuantityDelivered") 
    //       {
    //         setErrorMessage({ ...errorMessage, totalCbQuantityDeliveredError: "" });
    //       }

    //       if (e.target.name === "unrestrictedQuantity") 
    //       {
    //         setErrorMessage({ ...errorMessage, unrestrictedQuantityError: "" });
    //       }
    //       if (e.target.name === "restrictedQuantity") 
    //       {
    //         setErrorMessage({ ...errorMessage, restrictedQuantityError: "" });
    //       }
    //       if (e.target.name === "scrapQuantity") 
    //       {
    //         setErrorMessage({ ...errorMessage, scrapQuantityError: "" });
    //       }
    //   }

    //   useEffect(() => {
    //     if (plantConsumptionResponse) {
    //       if (plantConsumptionResponse.isSuccess === true) {
    //         confirmAlert({
    //           customUI: ({ onClose }) => {
    //             return (
    //               <ConfirmPopover
    //                 title={plantConsumptionResponse?.message}
    //                 onClose={onClose}
    //                 hideLink={true}
    //               ></ConfirmPopover>
    //             );
    //           },
    //         });

    //       } else {
    //         confirmAlert({
    //           customUI: ({ onClose }) => {
    //             return (
    //               <ErrorPopover onClose={onClose} title={ plantConsumptionResponse?.message} hideLink={true}/>
    //             );
    //           },
    //         });

    //       }
    //     }
    //   }, [plantConsumptionResponse]);

    return (
        <div>
            <Container fluid>
                <Row>
                    {/* <Col xs={12} md={3} className='common-internal-sidebar-col'>
                        <div className="common-internal-sidebar-container">
                            <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate('/Sidebar'))} />
                        </div>
                    </Col> */}
                    <Col xs={12} md={12}>
                        <div>
                        {!PROD &&    <p style={{textAlign:"center", fontSize:"2vh"}}>PIT30</p> }
                            <form>
                                <Container fluid>
                                    <div className='headingStylePIT'>Transporter Entry at Plant Gate</div>
                                    <Row>
                                        <Col xs={12} md={4}>

                                            <div className="consignment-pick-up-consignment-label" >ASN No.<span className='mandatory_field'>*</span></div>
                                            <input className='consignment-pick-up-textfields' name="consumptionQuantity" type="number" onFocus={handleNumberFieldFocus} />
                                            {/* <div className="error-msg">
                                           {errorMessage.consumptionQuantityError}
                                      </div> */}
                                            <div className="consignment-pick-up-consignment-label" >Odometer Reading<span className='mandatory_field'>*</span></div>
                                            <input className='consignment-pick-up-textfields' name="totalCbQuantityDelivered" type="number" onFocus={handleNumberFieldFocus} />
                                            {/* <div className="error-msg">
                                           {errorMessage.totalCbQuantityDeliveredError}
                                      </div> */}

                                        </Col>
                                    </Row>
                                </Container>
                            </form>
                        </div>
                        <Row>
                            <Col xs={12} md={6}>
                                <div class="plant_cb_submit-div">
                                    <button className='plant_cb_submit-Btn' type='submit' >End Trip</button>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default TransporterEntry;
